import { u } from "../lib/images";

// REAL current initiative. Do not add fictional activities here —
// new activities are added only when they genuinely launch.
export const activities = [
  {
    slug: "1-lakh-steps-for-paws",
    title: "1 Lakh Steps for Paws",
    pillar: "animals",
    status: "active",
    isSample: false,
    image: "/photos/activity-steps.webp",
    imageAlt: "A calm indie dog resting on the ground in dappled light",
    summary:
      "A free public community walking challenge — 1,00,000 combined steps, walked together for street-animal welfare.",
    description:
      "1 Lakh Steps for Paws is The PilCoo Foundation's free public community walking challenge. The goal is simple: 1,00,000 combined community steps, pooled from everyone who takes part. It uses movement and community participation to create awareness and engagement around animal welfare — no entry fee, no fitness requirement, no special equipment. Walk where you are, at your own pace, and add your steps to something shared.",
    details: [
      "Free and open to everyone",
      "Goal: 1,00,000 combined community steps",
      "Daily cap: 20,000 steps per participant",
      "Walk anywhere — your street, your park, your pace",
    ],
    ctaLabel: "Join the Challenge",
    externalUrl: "https://www.mypacer.com/challenges/bxr5sj80/1-lakh-steps-for-kindness",
    progress: {
      current: 120827,
      goal: 100000,
      daysRemaining: 22,
      note: "Goal crossed. And we're still walking. Our community has already walked beyond the original 1,00,000-step goal — with 22 days still to go.",
    },
    communityUrl:
      "https://www.mypacer.com/clubs/4wo25y6v/the-pilcoo-foundation-bengaluru-karnataka?invitor=23y3vx85&short_id=729pCq1",
  },
];
